import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const OfertaPage = lazy(() => import('../pages/oferta/page'));
const CzysciwaPrzemyslowePage = lazy(() => import('../pages/czysciwa-przemyslowe/page'));
const RecznikiPapierowePage = lazy(() => import('../pages/reczniki-papierowe/page'));
const DozownikiPage = lazy(() => import('../pages/dozowniki/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const ZapytanieOfertowePage = lazy(() => import('../pages/zapytanie-ofertowe/page'));
const KontaktPage = lazy(() => import('../pages/kontakt/page'));
const OFirmiePage = lazy(() => import('../pages/o-firmie/page'));
const CertyfikatyPage = lazy(() => import('../pages/certyfikaty/page'));
const DostawaIRealizacjaPage = lazy(() => import('../pages/dostawa-i-realizacja/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const JakWybracPage = lazy(() => import('../pages/jak-wybrac/page'));
const PrzykladyZastosowanPage = lazy(() => import('../pages/przyklady-zastosowan/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/oferta',
    element: <OfertaPage />,
  },
  {
    path: '/czysciwa-przemyslowe',
    element: <CzysciwaPrzemyslowePage />,
  },
  {
    path: '/reczniki-papierowe',
    element: <RecznikiPapierowePage />,
  },
  {
    path: '/dozowniki',
    element: <DozownikiPage />,
  },
  {
    path: '/produkt/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/zapytanie-ofertowe',
    element: <ZapytanieOfertowePage />,
  },
  {
    path: '/kontakt',
    element: <KontaktPage />,
  },
  {
    path: '/o-firmie',
    element: <OFirmiePage />,
  },
  {
    path: '/certyfikaty',
    element: <CertyfikatyPage />,
  },
  {
    path: '/dostawa-i-realizacja',
    element: <DostawaIRealizacjaPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/jak-wybrac',
    element: <JakWybracPage />,
  },
  {
    path: '/przyklady-zastosowan',
    element: <PrzykladyZastosowanPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
